import React from "react";

import { cx } from "~/tools/class-variance";

import styles from "./_progress-bar.module.css";
export interface ProgressBarProps {
	timeout?: number;
	className?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ timeout = 15_000, className, ...rest }) => {
	// historically timeout could be either seconds or milliseconds
	const timeoutMs = timeout < 100 ? timeout * 1000 : timeout;

	return (
		<div className={cx(styles.progressBar, className)} data-testid="progress-bar" {...rest}>
			<div
				className={styles.innerProgressBar}
				style={{
					animationDuration: `${timeoutMs}ms`,
				}}
			/>
		</div>
	);
};
